<div class="display-flex-with-align-center-and-justify-center">
  <mat-card
    class="reset-password-card display-flex-with-align-center-and-justify-center">
    <mat-card-header class="header-holder">
      <img
        priority
        ngSrc="assets/talentmarket.logo.svg"
        routerLink="/home"
        alt="talentmarket."
        class="logo-card cursor-pointer"
        height="100"
        width="250" />
    </mat-card-header>

    <mat-card-content>
      <!-- Forma za novu lozinku -->
      <div *ngIf="!resetSuccess && !resetError" class="form-holder">
        <h2>{{ 'auth.resetPassword.title' | translate }}</h2>
        <p class="description">
          {{ 'auth.resetPassword.description' | translate }}
        </p>

        <form (ngSubmit)="onReset()">
          <mat-form-field appearance="fill" class="width-full">
            <mat-label>{{ 'auth.resetPassword.newPasswordLabel' | translate }}</mat-label>
            <input
              matInput
              [type]="hideNewPassword ? 'password' : 'text'"
              [(ngModel)]="newPassword"
              name="newPassword"
              [placeholder]="'auth.resetPassword.newPasswordPlaceholder' | translate"
              required
              minlength="6"
              autocomplete="new-password" />
            <button
              type="button"
              mat-icon-button
              matSuffix
              (click)="hideNewPassword = !hideNewPassword">
              <mat-icon>{{
                hideNewPassword ? 'visibility_off' : 'visibility'
              }}</mat-icon>
            </button>
          </mat-form-field>
          <mat-hint *ngIf="newPassword && newPassword.length < 6" class="password-hint">
            {{ 'auth.resetPassword.passwordMinLength' | translate }}
          </mat-hint>

          <mat-form-field appearance="fill" class="width-full">
            <mat-label>{{ 'auth.resetPassword.confirmPasswordLabel' | translate }}</mat-label>
            <input
              matInput
              [type]="hideConfirmPassword ? 'password' : 'text'"
              [(ngModel)]="confirmPassword"
              name="confirmPassword"
              [placeholder]="'auth.resetPassword.confirmPasswordPlaceholder' | translate"
              required
              autocomplete="new-password" />
            <button
              type="button"
              mat-icon-button
              matSuffix
              (click)="hideConfirmPassword = !hideConfirmPassword">
              <mat-icon>{{
                hideConfirmPassword ? 'visibility_off' : 'visibility'
              }}</mat-icon>
            </button>
          </mat-form-field>
          <mat-error
            *ngIf="!passwordsMatch && confirmPassword"
            class="error-text">
            {{ 'auth.resetPassword.passwordsMismatch' | translate }}
          </mat-error>

          <button
            mat-raised-button
            color="primary"
            type="submit"
            class="submit-btn"
            [disabled]="loading || !isFormValid">
            {{
              loading
                ? ('auth.resetPassword.resetting' | translate)
                : ('auth.resetPassword.resetButton' | translate)
            }}
          </button>
        </form>
      </div>

      <!-- Uspjeh -->
      <div *ngIf="resetSuccess" class="success-message">
        <mat-icon class="success-icon">check_circle</mat-icon>
        <h2>{{ 'auth.resetPassword.successTitle' | translate }}</h2>
        <p>{{ 'auth.resetPassword.successMessage' | translate }}</p>

        <div class="login-button">
          <a routerLink="/signin">
            <button mat-raised-button color="primary">
              {{ 'auth.resetPassword.goToLogin' | translate }}
            </button>
          </a>
        </div>
      </div>

      <!-- Error — token nevažeći ili istekao -->
      <div *ngIf="resetError" class="error-message">
        <mat-icon class="error-icon">error</mat-icon>
        <h2>{{ 'auth.resetPassword.errorTitle' | translate }}</h2>
        <p class="error-text">{{ resetError }}</p>

        <div class="action-buttons">
          <a routerLink="/forgot-password">
            <button mat-raised-button color="primary">
              {{ 'auth.resetPassword.requestNewLink' | translate }}
            </button>
          </a>
          <a routerLink="/signin">
            <button mat-stroked-button>
              {{ 'auth.resetPassword.backToLogin' | translate }}
            </button>
          </a>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
